import { useEffect, useState } from "react";
import { useStore } from "zustand";
import { useDashboardName } from "../../store/headerName";
import CustomBreadcrumb from "../../components/CustomBreadcrumb";
import ButtonIcon from "../../components/ButtonIcon";
import BaseCard from "../../components/card/BaseCard";
import Status from "../../components/Status";
import { Button, Descriptions, Table, type TableProps } from "antd";
import {
  formatDate,
  GetFullMediaPath,
  numberFormatterLabel,
} from "../../helper/method";
import { useParams } from "react-router";
import { $api, type components } from "../../helper";
import { contactMock, tokenMock } from "../../helper/mock";
import ConfirmModal from "../../components/modal/ConfirmModal";
import { useNotify } from "../../helper/notify";
import BaseTable from "../../components/BaseTable";

export default function InvoiceDetail() {
  const { setDashboardName } = useStore(useDashboardName);
  const params = useParams();
  const notify = useNotify();
  const [isOpen, setIsOpen] = useState(false);
  const { mutate, isPending } = $api.useMutation(
    "put",
    "/site-api/v1/sell-factor-delivery-status/",
  );
  const { data, isLoading, refetch } = $api.useQuery(
    "get",
    "/site-api/v1/sell-factor-detail/",
    {
      params: {
        query: {
          sell_factor_u_id: params.id ?? "",
        },
      },
      headers: {
        Authorization: tokenMock,
        lang: "fa",
      },
    },
  );
  useEffect(() => {
    setDashboardName("جزئیات فاکتور");
  }, []);

  const columns: TableProps<
    components["schemas"]["SiteSellFactorProductDetailItem"]
  >["columns"] = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      render: (_, record, index) => <span>{index + 1}</span>,
    },
    {
      title: "محصول",
      dataIndex: "image",
      key: "image",
      render: (_, record) => (
        <div className="flex gap-2 items-center">
          <div className="aspect-square w-16 rounded-lg overflow-hidden">
            <img
              src={GetFullMediaPath(record.image)}
              alt=""
              className="w-full h-full object-cover"
            />
          </div>
          <span className="text-16-regular">{record.title}</span>
        </div>
      ),
    },
    {
      title: "عنوان دسته بندی",
      dataIndex: "category_title",
      key: "category_title",
      // className: "print:hidden",
    },
    {
      title: "تعداد",
      dataIndex: "count",
      key: "count",
    },
    {
      title: "قیمت واحد",
      dataIndex: "unit_price",
      key: "unit_price",
      render: (_, record) => (
        <span className="text-16-regular">
          {numberFormatterLabel(record.unit_price)}
        </span>
      ),
    },
    {
      title: "نوع",
      dataIndex: "type",
      // className: "print:hidden",
      key: "type",
      render: (_, record) => (
        <Status
          title={record.type === 1 ? "محصول" : "دوره"}
          style={"success"}
        />
      ),
    },
    {
      title: "جمع کل",
      dataIndex: "total",
      key: "total",
      render: (_, record) => (
        <span className="text-16-regular">
          {numberFormatterLabel(record.total)}
        </span>
      ),
    },
  ];

  return (
    <div className="flex flex-col gap-6">
      {/* modal */}
      <ConfirmModal
        action={() => {
          mutate(
            {
              body: {
                sell_factor_u_id: params.id ?? "",
                delivery_status:
                  data?.data.factor_detail.delivery_status === 1 ? 2 : 1,
              },
              headers: {
                Authorization: tokenMock,
                lang: "fa",
              },
            },
            {
              onSuccess: (data) => {
                notify.success(data.message);
                setIsOpen(false);
                refetch();
              },
            },
          );
        }}
        description="ایا مطمعن هستید که میخواهید وضعیت تحویل را تغییر دهید ؟"
        onClose={() => setIsOpen(false)}
        open={isOpen}
        pending={isPending}
        success
        title="تغییر وضعیت تحویل"
      />
      <div className="w-full print:hidden flex justify-between items-center">
        <CustomBreadcrumb
          items={[
            {
              title: "لیست فاکتور ها",
              href: "/invoices-list",
            },
            {
              title: "جزئیات فاکتور",
            },
          ]}
        />
      </div>
      <div className="w-full print:hidden items-center flex justify-between">
        <ButtonIcon
          onClick={() => {
            window.print();
          }}
          icon="solar:printer-minimalistic-bold"
        />
        <Button onClick={() => setIsOpen(true)} type="primary">
          تغییر وضعیت تحویل
        </Button>
      </div>
      <BaseCard
        props={{
          className: "flex flex-col gap-6",
        }}
      >
        <div className="w-full grid sm:grid-cols-3 gap-4 sm:gap-0 grid-cols-1 border-b border-grayscale-100 pb-4 print:p-4 items-center">
          <span className="text-20-regular col-span-1">فاکتور فروش</span>
          <div className="col-span-1 flex sm:justify-center">
            <div className="w-12 h-12">
              <img
                src="/image/Vector(1).png"
                alt=""
                className="w-full h-full"
              />
            </div>
          </div>
          <div className="flex items-center sm:justify-end gap-2 col-span-1">
            <span className="text-nowrap">وضعیت پرداخت : </span>
            <Status
              title={
                data?.data.factor_detail.settlement_status === 1
                  ? "پرداخت شده"
                  : "در انتظار پرداخت"
              }
              style={
                data?.data.factor_detail.settlement_status === 1
                  ? "success"
                  : "warning"
              }
            />
          </div>
        </div>

        <div className="grid sm:grid-cols-3 sm:gap-0 gap-4 grid-cols-1 print:px-2.5">
          <div className="col-span-1">
            <span>شماره فاکتور : </span>
            {data?.data.factor_detail.code}
          </div>
          <div className="col-span-1 text-nowrap flex sm:justify-center">
            <span>تاریخ ایجاد : </span>
            {formatDate(data?.data.factor_detail.created)}
          </div>
          <div className="col-span-1 sm:justify-end flex">
            <span className="text-nowrap">وضعیت ارسال : </span>
            <Status
              title={
                data?.data.factor_detail.delivery_status === 1
                  ? "تحویل داده شده"
                  : "در انتظار تحویل"
              }
              style={
                data?.data.factor_detail.delivery_status === 1
                  ? "success"
                  : "warning"
              }
            />
          </div>
        </div>

        <div className="w-full">
          <div className="py-2.5 border border-grayscale-100 text-18-regular text-center rounded-t-2xl">
            مشخصات مشتری
          </div>
          <div className="p-2.5 gap-y-4 border-x border-grayscale-100 border-b">
            <Descriptions
              items={[
                {
                  label: "نام مشتری",
                  children: data?.data.factor_detail.user_name,
                },
                {
                  label: "تلفن",
                  children: data?.data.factor_detail.phone_number,
                },
                {
                  label: "کدپستی",
                  children: data?.data.factor_detail.postal_code,
                },
                { label: "آدرس", children: data?.data.factor_detail.address },
              ]}
            />
          </div>
          <div className="">
            <BaseTable props={{ className: "w-full grid! grid-cols-1!" }}>
              <Table<components["schemas"]["SiteSellFactorProductDetailItem"]>
                loading={isLoading}
                className="col-span-1!"
                scroll={{ x: "max-content" }}
                classNames={{
                  header: { wrapper: "tb-r" },
                }}
                bordered
                pagination={false}
                columns={columns}
                dataSource={data?.data.product_detail}
                summary={(productData) => {
                  const total = productData.reduce(
                    (prev, current) => prev + current.total,
                    0,
                  );
                  return (
                    <>
                      <Table.Summary.Row>
                        <Table.Summary.Cell
                          className=""
                          index={1}
                          colSpan={5}
                        ></Table.Summary.Cell>
                        <Table.Summary.Cell index={6}>
                          <div className="w-full h-full flex flex-col gap-4">
                            <span className="text-16-regular text-grayscale-600">
                              مبلغ فاکتور
                            </span>
                          </div>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={7}>
                          <div className="w-full h-full flex flex-col gap-4">
                            <span className="text-16-regular">
                              {numberFormatterLabel(total)}
                            </span>
                          </div>
                        </Table.Summary.Cell>
                      </Table.Summary.Row>
                      <Table.Summary.Row>
                        <Table.Summary.Cell
                          className=""
                          index={1}
                          colSpan={5}
                        ></Table.Summary.Cell>
                        <Table.Summary.Cell index={6}>
                          <div className="w-full h-full flex flex-col gap-4">
                            <span className="text-16-regular text-grayscale-600">
                              هزینه ارسال
                            </span>
                          </div>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={7}>
                          <div className="w-full h-full flex flex-col gap-4">
                            <span className="text-16-regular">
                              {numberFormatterLabel(
                                data?.data.total_pay_detail.shipping ?? 0,
                              )}
                            </span>
                          </div>
                        </Table.Summary.Cell>
                      </Table.Summary.Row>
                      <Table.Summary.Row>
                        <Table.Summary.Cell
                          className=""
                          index={1}
                          colSpan={5}
                        ></Table.Summary.Cell>
                        <Table.Summary.Cell index={6}>
                          <div className="w-full h-full flex flex-col gap-4">
                            <span className="text-16-regular text-grayscale-600">
                              تخفیف
                            </span>
                          </div>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={7}>
                          <div className="w-full h-full flex flex-col gap-4">
                            <span className="text-16-regular">
                              {numberFormatterLabel(
                                data?.data.total_pay_detail.discount ?? 0,
                              )}
                            </span>
                          </div>
                        </Table.Summary.Cell>
                      </Table.Summary.Row>
                      <Table.Summary.Row>
                        <Table.Summary.Cell
                          className=""
                          index={1}
                          colSpan={5}
                        ></Table.Summary.Cell>
                        <Table.Summary.Cell index={6}>
                          <div className="w-full h-full flex flex-col gap-4">
                            <span className="text-16-regular text-grayscale-600">
                              مالیات
                            </span>
                          </div>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={7}>
                          <div className="w-full h-full flex flex-col gap-4">
                            <span className="text-16-regular">
                              {numberFormatterLabel(
                                data?.data.total_pay_detail.taxes ?? 0,
                              )}
                            </span>
                          </div>
                        </Table.Summary.Cell>
                      </Table.Summary.Row>
                      <Table.Summary.Row>
                        <Table.Summary.Cell
                          className=""
                          index={1}
                          colSpan={5}
                        ></Table.Summary.Cell>
                        <Table.Summary.Cell index={6}>
                          <div className="w-full h-full flex flex-col gap-4">
                            <span className="text-16-regular text-grayscale-600">
                              جمع کل
                            </span>
                          </div>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={7}>
                          <div className="w-full h-full flex flex-col gap-4">
                            <span className="text-16-regular">
                              {numberFormatterLabel(
                                data?.data.total_pay_detail.total_pay ?? 0,
                              )}
                            </span>
                          </div>
                        </Table.Summary.Cell>
                      </Table.Summary.Row>
                      <Table.Summary.Row>
                        <Table.Summary.Cell
                          className=""
                          index={1}
                          colSpan={5}
                        ></Table.Summary.Cell>
                        <Table.Summary.Cell index={6}>
                          <div className="w-full h-full flex flex-col gap-4">
                            <span className="text-16-regular text-grayscale-600">
                              باقی مانده
                            </span>
                          </div>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={7}>
                          <div className="w-full h-full flex flex-col gap-4">
                            <span className="text-16-regular">
                              {numberFormatterLabel(
                                data?.data.total_pay_detail.remaining_paid ?? 0,
                              )}
                            </span>
                          </div>
                        </Table.Summary.Cell>
                      </Table.Summary.Row>
                    </>
                  );
                }}
              />
            </BaseTable>
          </div>

          <div className="flex flex-col gap-4 border-x border-b rounded-b-2xl border-grayscale-100 p-2.5">
            <div className="flex flex-col gap-1">
              <span className="text-16-semi-bold">توضیحات</span>
              <span>{data?.data?.factor_detail.description}</span>
            </div>
            <div className="flex flex-col print:hidden gap-1">
              <span className="text-16-semi-bold">یادداشت</span>
              <span>{data?.data?.factor_detail.note}</span>
            </div>
            <Descriptions
              items={data?.data?.print_detail.map((e) => ({
                label: contactMock?.find((c) => Number(c.value) === e.title)
                  ?.label,
                children: e.value,
              }))}
            />
          </div>
        </div>
      </BaseCard>
    </div>
  );
}
